const survey = state => state.survey;
const answering = state => state.api.post.answer.sending;
const fetching = state => state.api.get.fetching;

export default {
  survey,
  answering,
  fetching
}
